import type { BusinessUnitComponent } from '@zola-helpers/client/dist/es/@types';
import type { EventConfig } from '@zola/tracking-contracts/src/configs';
import type { CardType } from './cardTypes';

export const BUSINESS_UNIT_COMPONENT_TO_BUSINESS_CATEGORY_MAP: Record<
  BusinessUnitComponent,
  EventConfig['business_category']
> = {
  BUDGET_TOOL: 'UNATTRIBUTED',
  CHANGE_THE_DATE: 'CHANGE_THE_DATE',
  COMMUNITY: 'UNATTRIBUTED',
  DAY_OF_PAPER: 'DAY_OF',
  DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATE',
  HOLIDAY: 'HOLIDAY',
  INSPIRATION: 'UNATTRIBUTED',
  INVITATIONS: 'INVITATIONS',
  MARKETPLACE: 'UNATTRIBUTED',
  REGISTRY: 'UNATTRIBUTED',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
  SEATING_CHART: 'UNATTRIBUTED',
  STORE: 'UNATTRIBUTED',
  THANK_YOU_CARDS: 'THANK_YOU',
  WEDDING_ALBUM: 'UNATTRIBUTED',
  WEDDING_CHECKLIST: 'UNATTRIBUTED',
  WEDDING_GUEST_LIST: 'UNATTRIBUTED',
  WEDDING_PLANNING: 'UNATTRIBUTED',
  WEDDING_SHOWER_INVITATION: 'WEDDING_SHOWER_INVITATION',
  WEDDING_WEBSITE: 'UNATTRIBUTED',
  WEDDINGS: 'UNATTRIBUTED',
};

export const CARD_TYPE_TO_BUSINESS_CATEGORY_MAP: Record<
  CardType,
  EventConfig['business_category']
> = {
  BELLY_BAND: 'BELLY_BAND',
  CHANGE_THE_DATE: 'CHANGE_THE_DATE',
  DETAILS: 'ENCLOSURE',
  DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATE',
  ENCLOSURE: 'ENCLOSURE',
  ENVELOPE: 'UNATTRIBUTED',
  HOLIDAY: 'HOLIDAY',
  INVITATION: 'INVITATIONS',
  INVITATION_ENVELOPE: 'UNATTRIBUTED',
  MATCHING_SUITES: 'UNATTRIBUTED',
  MENU: 'MENU',
  NAPKIN: 'NAPKIN',
  PAPER_ADD_ONS: 'PAPER_ADD_ONS',
  PLACE: 'PLACE',
  PROGRAM: 'PROGRAM',
  RSVP: 'UNATTRIBUTED',
  RSVP_ENVELOPE: 'UNATTRIBUTED',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
  SIGNAGE: 'SIGNAGE',
  STICKER: 'STICKER',
  TABLE_NUMBER: 'TABLE_NUMBER',
  THANK_YOU: 'THANK_YOU',
  VELLUM_JACKET: 'VELLUM_JACKET',
  WAX_SEAL: 'WAX_SEAL',
  WEDDING_SHOWER_INVITATION: 'WEDDING_SHOWER_INVITATION',
};
